import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../assets/images/eezy-logo-round.svg';
import { SignOutButton } from './SignOutButton';
import LanguageOptions from './LanguageOptions';
import { getLanguage, UiLanguage } from '../utils/i18n';

interface IProps {
    userFullName?: string;
}

function TopBar(props: IProps) {
    const { t } = useTranslation();
    const pages = ['sales-pages', 'payments', 'subscriptions'];

    const navigate = useNavigate();
    const { userFullName } = props;
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
        null,
    );

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleMenuItemClick = (page: string) => {
        navigate(`/${page.replace(' ', '-')}`);
    };

    return (
        <AppBar position="sticky">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: { xs: 'flex', md: 'none' },
                        }}
                    >
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {pages.map((page) => (
                                <MenuItem
                                    key={page}
                                    onClick={() => {
                                        handleCloseNavMenu();
                                        handleMenuItemClick(page);
                                    }}
                                >
                                    <Typography textAlign="center">
                                        {t(`menu.${page}`)}
                                    </Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <img
                        src={logo}
                        alt="Logo"
                        height="40px"
                        style={{ margin: '0 10px' }}
                    />
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        href=""
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontWeight: 700,
                            letterSpacing: '.1rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        {userFullName}
                    </Typography>
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: { xs: 'none', md: 'flex' },
                        }}
                    >
                        {pages.map((page) => (
                            <Button
                                key={page}
                                onClick={() => {
                                    handleCloseNavMenu();
                                    handleMenuItemClick(page);
                                }}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                {t(`menu.${page}`)}
                            </Button>
                        ))}
                    </Box>
                    <LanguageOptions language={getLanguage() as UiLanguage} />
                    <Typography
                        variant="subtitle1"
                        noWrap
                        component="a"
                        href="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontWeight: 700,
                            letterSpacing: '.1rem',
                            color: 'inherit',
                            textDecoration: 'none',
                            marginLeft: '1rem',
                        }}
                    >
                        {userFullName}
                    </Typography>
                    <Box sx={{ flexGrow: 0 }}>
                        <SignOutButton />
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default TopBar;
